import { atom } from 'recoil'
import { StudentTypes } from 'services'

export const studentsList = atom<StudentTypes[]>({
  key: 'studentsList',
  default: []
})
